import React, { useEffect, useState } from "react";
import { api } from "../../api/api";
import { Controller, useForm } from "react-hook-form";
import SelectM from "../../hookFormComponents.tsx/Select";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button } from "@mui/material";
import axios from "axios";
import { Input } from "../../hookFormComponents.tsx/Input";

interface Setting {
  key: string;
  value: any;
  type: string;
}

interface FormValues {
  auto_accept_appointments: boolean;
  auto_assign_employees: boolean;
  time_slot_minutes: number;
  timezone: string;
}

function Settings() {
  const [settings, setSettings] = useState<Setting[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/settings")
      .then((res) => {
        setSettings(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
        setLoading(false);
      });
  }, []);

  const validationSchema = Yup.object({
    auto_accept_appointments: Yup.boolean().required("Required"),
    auto_assign_employees: Yup.boolean().required("Required"),
    time_slot_minutes: Yup.number()
      .required("Required")
      .typeError("Must be a number")
      .min(1, "Must be greater than 0"),
    timezone: Yup.string().required("Required"),
  });

  const {
    formState: { errors },
    control,
    handleSubmit,
    setValue,
    register,
    reset,
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (settings.length) {
      const defaultValues = {
        auto_accept_appointments:
          settings.find((setting) => setting.key === "auto_accept_appointments")
            ?.value || false,
        auto_assign_employees:
          settings.find((setting) => setting.key === "auto_assign_employees")
            ?.value || false,
        time_slot_minutes:
          settings.find((setting) => setting.key === "time_slot_minutes")
            ?.value || 30,
        timezone:
          settings.find((setting) => setting.key === "timezone")?.value || "",
      };
      reset(defaultValues);
    }
  }, [settings, reset]);

  const onSubmit = (values: FormValues) => {
    api.post("/settings", values);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Box sx={{ padding: "10px 20px" }}>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="auto_accept_appointments"
          render={({ field }) => (
            <SelectM
              label="Auto Accept Appointments"
              required
              value={field.value ? "1" : "0"}
              name={field.name}
              setValue={setValue}
              errors={errors}
              options={[
                { label: "Yes", value: 1 },
                { label: "No", value: 0 },
              ]}
            />
          )}
        />
        <Controller
          control={control}
          name="auto_assign_employees"
          render={({ field }) => (
            <SelectM
              label="Auto Assign Employees"
              required
              value={field.value ? "1" : "0"}
              name={field.name}
              setValue={setValue}
              errors={errors}
              options={[
                { label: "Yes", value: 1 },
                { label: "No", value: 0 },
              ]}
            />
          )}
        />

        <Input
          required
          {...register("time_slot_minutes")}
          label={"Time Slot(minutes)"}
          type="text"
          error={errors?.time_slot_minutes?.message}
        />
        <Input
          required
          {...register("timezone")}
          label={"Timezone"}
          type="text"
          error={errors?.timezone?.message}
        />

        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button type="submit" variant="contained">
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
}

export default Settings;
